import { Link } from 'react-router-dom';
import { channels } from '@/mocks/channels';
import { brand, socials } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-800 text-primary-100">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 md:grid-cols-12 md:px-6">
        {/* brand */}
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-accent-400 text-lg font-black text-primary-900">
              瓜
            </span>
            <span className="text-2xl font-black text-background-50">热瓜速递</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
            {brand.slogan}。覆盖娱乐八卦、明星资讯、网红爆料、影视综艺与社会热点五大栏目，
            按兴趣一键直达，陪你理性又有趣地度过每个茶余饭后。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {socials.map((s) => (
              <span
                key={s.name}
                className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-700/70 text-primary-100 transition-colors hover:bg-primary-600 hover:text-background-50"
                title={s.name}
              >
                <i className={`${s.icon} text-lg`} aria-hidden="true" />
              </span>
            ))}
          </div>
        </div>

        {/* 栏目 */}
        <nav className="md:col-span-3" aria-label="页脚栏目">
          <h4 className="mb-4 text-sm font-semibold text-background-50">栏目导航</h4>
          <ul className="grid grid-cols-2 gap-x-2 gap-y-2.5 text-sm">
            {channels.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/channel/${c.slug}`}
                  className="whitespace-nowrap text-primary-200 transition-colors hover:text-background-50"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* 快捷 */}
        <nav className="md:col-span-2" aria-label="页脚快捷">
          <h4 className="mb-4 text-sm font-semibold text-background-50">快捷入口</h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/" className="text-primary-200 transition-colors hover:text-background-50">
                首页
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-primary-200 transition-colors hover:text-background-50">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/about#contact" className="text-primary-200 transition-colors hover:text-background-50">
                投稿爆料
              </Link>
            </li>
            <li>
              <Link to="/about#faq" className="text-primary-200 transition-colors hover:text-background-50">
                常见问题
              </Link>
            </li>
          </ul>
        </nav>

        {/* 联系 */}
        <div className="md:col-span-2">
          <h4 className="mb-4 text-sm font-semibold text-background-50">联系方式</h4>
          <p className="text-sm leading-relaxed text-primary-200">意见与投稿请通过“我要爆料”表单提交，我们会认真查看每一条留言。</p>
          <a
            href={`mailto:${brand.email}`}
            className="mt-3 inline-flex items-center gap-1.5 text-sm text-background-50 underline decoration-accent-400 underline-offset-4"
          >
            <i className="ri-mail-line" aria-hidden="true" /> {brand.email}
          </a>
        </div>
      </div>

      <div className="border-t border-primary-700/60">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-300 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 热瓜速递 · 娱乐八卦资讯门户</p>
          <p className="text-center sm:text-right">理性吃瓜 · 尊重边界 · 让内容有温度</p>
        </div>
      </div>
    </footer>
  );
}